import springApi from '../../services/springApi'

export const sendPushNotification = data => (
	new Promise((resolve, reject) => {
		springApi()
			.post('/push_notifications/send', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)